import { useState } from 'react';
import styles from './ConfirmStartTreatmentModal.module.scss';
import { Button, Modal, Text } from 'components';
import { appActions } from 'store/app/slice';
import { selectCurrentPatientCase, selectPatientPageTimestamp } from 'store/patients/selectors';
import { patientsActions } from 'store/patients/slice';
import { useDispatch, useSelector } from 'store/utils';
import { TreatmentPlanTask, TypeOfMessages } from 'types';

export const ConfirmStartTreatmentModal = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const currentPatientCase = useSelector(selectCurrentPatientCase);

  const onClose = () => {
    dispatch(appActions.setIsModalOpened({ name: 'startTreatment', isOpened: false }));
  };

  const onSubmit = async () => {
    if (!currentPatientCase?.id || isLoading) return;

    try {
      setIsLoading(true);
      await dispatch(
        patientsActions.updatePatientCase({
          patientCaseData: {
            task: TreatmentPlanTask.IN_TREATMENT,
          },
          patientCaseId: currentPatientCase?.id,
        }),
      ).unwrap();

      await dispatch(
        patientsActions.sendPatientMessage({
          messageData: { body: `“PATIENT HAS STARTED TREATMENT”`, type: TypeOfMessages.TEXT },
          patientCaseId: currentPatientCase?.id,
        }),
      );

      onClose();
    } catch (e: unknown) {
      onClose();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title={'Start treatment'} onClose={onClose}>
      <div className={styles.container}>
        <Text type="body-big">Are you sure you want to proceed with START TREATMENT?</Text>
        <div className={styles.descriptionText}>
          <Text type="body2" className={styles.helpMessage}>
            Please be aware that all previously entered data (text, links, and images) will be locked and no changes
            will be allowed after confirming!
          </Text>
        </div>
        <div className={styles.buttonRow}>
          <Button isLink onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSubmit}>CONFIRM START TREATMENT</Button>
        </div>
      </div>
    </Modal>
  );
};
